{
  "reminder": {
    "overdue": "Ingen kontrollpunkt för granskningsloggen har skrivits ut det senaste dygnet. Skriv ut en och arkivera den — den visar i efterhand att loggen inte har ändrats.",
    "never": "Ingen kontrollpunkt för granskningsloggen har skrivits ut på den här enheten. Skriv ut en och arkivera den — den visar i efterhand att loggen inte har ändrats.",
    "last": "Senaste kontrollpunkt för granskningsloggen: {printedAt}.",
    "print": "Skriv ut kontrollpunkt"
  },
  "sheet": {
    "title": "Kontrollpunkt för granskningsloggen",
    "explanation": "Bladet anger en rad i granskningsloggen och dess kontrollsumma. Arkivera det utanför enheten. Om loggen skulle ändras i efterhand stämmer kontrollsumman inte längre, och det går att visa med kommandot nedan.",
    "seq": "Löpnummer",
    "hash": "Kontrollsumma",
    "fingerprint": "Fingeravtryck",
    "anchoredAt": "Raden skrevs",
    "printedAt": "Bladet skrevs ut",
    "commandHeading": "Kontroll mot det här bladet",
    "commandExplanation": "Körs av teknikern på enheten. Båda värdena är redan ifyllda och ska inte ändras.",
    "fingerprintNote": "Fingeravtrycket är de första tecknen i kontrollsumman, för att jämföra med ögat. Det är kontrollsumman som gäller.",
    "notVerified": "Bladet är inte en kontroll av loggen. Det är en fast punkt som en senare kontroll utgår från.",
    "failed": "Kontrollpunkten kunde inte hämtas. Försök igen.",
    "retry": "Försök igen",
    "intro": "Bladet tas fram och skrivs ut när du trycker på knappen. Först då räknas det som utskrivet — går du tillbaka innan dess skrivs ingenting in i loggen.",
    "produce": "Skriv ut kontrollpunkt",
    "producing": "Tar fram kontrollpunkten …",
    "back": "Tillbaka till avdelningslistan"
  }
}
